import instance from '..';

export default class OutOfLicenceAPI {
  static async notifyOutOfLicence(token, data) {
    return instance.post('/api/notify_out_of_licence/', data, {
      headers: { Authorization: `Token ${token}` }
    });
  }
}
